import gql from 'graphql-tag';

const UNLINK_DSP_ADVERTISER = gql`
  mutation unlinkDspAdvertiser($id: ID!) {
    updateOrg(
      data: { dataConfig: { update: { dspAdvertiserId: null } } }
      where: { id: $id }
    ) {
      id
      dataConfig {
        dspAdvertiserId
      }
    }
  }
`;

export default UNLINK_DSP_ADVERTISER;
